import {getIn as get} from 'formik';

export default get;
